import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { ndsFormStyles, ndsBoxSizing, ndsFontReset } from '@nicollet/common';
import { Label } from '../Label/index.js';

const focusStyles = `
  outline: ${ndsTokens.colors.text.formLabel} dashed 1px;
  outline-offset: 2px;
  -moz-outline-radius: 4px;
`;
const invalidStyles = `
  border-color: ${ndsFormStyles.colors.alert.warning.border};
`;
const validStyles = `
  border-color: ${ndsTokens.colors.alert.success};
`; // An outer wrapper so the <select> will predictably stack when placed with other form elements like Error Messages and Microcopy (display: block)

const SelectOuterWrap = styled.div`
  ${ndsBoxSizing};
  ${ndsFontReset()};
  display: block;
  position: relative;
`; // An inner wrapper so the <select> can be sized based on it's contents (display: inline-flex)

const selectWrapHoverStyles = `
  background: ${ndsTokens.colors.background.lightest};
`;
const SelectWrap = styled.div`
  background-color: ${props => {
  if (props.isValid === false) return ndsFormStyles.colors.alert.warning.background;
  if (props.variant === 'borderless') return 'transparent';
  return ndsTokens.colors.background.default;
}};

  /* Have to move background color here, putting it on the actual select causes FF to add a vertical scrollbar to the menu at all times */

  display: ${props => props.display};
  position: relative;

  ${props => props.hasHover && selectWrapHoverStyles};
  &:hover {
    ${selectWrapHoverStyles};
  }
`; // Resolving a linting error related to the capitalized nature of the Number method

const SelectInputPaddingRightValue = Number.parseInt(ndsTokens.space.generic.x2, 10);
const SelectInput = styled.select`
  appearance: none;

  /* background-color transparent doesn't trigger the menu bug in FF */

  background-color: transparent;
  color: ${ndsTokens.colors.text.onLight.primary};
  cursor: pointer;
  line-height: ${ndsTokens.font.lineHeight.text};
  border: 0;
  font-size: ${({
  elementSize
}) => elementSize === 'sm' ? ndsTokens.font.size.text.small : ndsTokens.font.size.text.base};
  margin: 0;
  outline: none;
  padding-left: ${ndsTokens.space.inset.x2};
  padding-right: ${SelectInputPaddingRightValue * 2 + 14}px;
  width: ${({
  width
}) => width !== null && width !== void 0 ? width : '100%'};

  &::-ms-expand {
    display: none;
  }

  :-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }

  &:disabled {
    background: ${ndsFormStyles.colors.background.disabled};
    color: ${ndsTokens.colors.messaging.disabled};
    cursor: not-allowed;
  }
  height: ${({
  elementSize
}) => elementSize === 'sm' ? '32px' : '44px'};
`;
const SelectVisual = styled.div`
  align-items: center;
  border-radius: 3px;
  border: 1px solid
    ${props => props.variant === 'borderless' ? 'transparent' : ndsTokens.colors.border.control.input};
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  left: 0;
  margin: 0;
  padding: ${ndsTokens.space.inset.x2};
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;

  ${props => props.hasFocus && focusStyles};
  ${SelectInput}:focus ~ & {
    ${focusStyles};
  }

  ${props => props.isValid === false && invalidStyles};
  ${props => props.isValid && validStyles};

  ${SelectInput}:disabled ~ & {
    border-color: ${ndsTokens.colors.interactive.disabled.default};
  }
`;
const SelectLabel = styled(Label)`
  max-width: calc(100% - ${ndsTokens.space.generic.x2});
  background: ${props => props.isFocused ? ndsTokens.colors.palette.white : 'transparent'};
  ${({
  elementSize
}) => elementSize === 'sm' && `font-size: ${ndsTokens.font.size.text.xsmall}`};
`;

export { SelectInput, SelectLabel, SelectOuterWrap, SelectVisual, SelectWrap };
